<template>
  <el-select
    :style="{ width: width }"
    size="small"
    v-model="capitalId"
    :loading="isLoading"
    filterable
    clearable
    remote
    :remote-method="getList"
    placeholder="请选择"
  >
    <el-option v-for="item in list" :label="item.capitalName" :value="item.id" :key="item.id"></el-option>
  </el-select>
</template>

<script>
import { getCapitalList } from './api.js';

export default {
  name: 'SelectCapital',

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '400px'
    }
  },

  computed: {
    capitalId: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false,
    }
  },

  created() {
    this.getList('');
  },

  methods: {
    async getList(query) {
      let params = { capitalName: query, status: true };
      this.list = await getCapitalList(params);
    }
  }
}
</script>

<style></style>
